<template>
  <div class="agreement-page">
    <div class="agreement-page__container">
      <!-- Loading skeleton -->
      <div v-if="loading" class="skeleton-wrapper">
        <div class="skeleton-title"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line short"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line short"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line short"></div>
        <div class="skeleton-title"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line short"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line short"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line short"></div>
      </div>

      <!-- privacy policy alanaı -->
      <div v-else-if="legalTextsData && Object.keys(legalTextsData).length" class="information-content">
        <div class="legal-section mb-4">
          <h1>{{ legalTextsData.privacy_notice.title }}</h1>
          <div v-html="legalTextsData.privacy_notice.html"></div>
        </div>
      </div>

      <!-- No data  -->
      <div v-else class="text-center py-5">
        <p>{{ $t('general.no_data') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/core/services";
import axios from "axios";
import i18nService from "@/core/services/i18n.service.js";
import company_module, {
  MODULE_NAME as COMPANY_MODULE_NAME,
} from "@/core/services/store/company.module";

export default {
  name: "AGREEMENT",
  data() {
    return {
      legalTextsData: {},
      loading: true,
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(COMPANY_MODULE_NAME, company_module);
  },
  computed: {
    company() {
      return store.getters[COMPANY_MODULE_NAME + "/" + "SELF"];
    },
    currentLocale() {
      return i18nService.getActiveLanguage();
    },
  },
  methods: {
    async fetchLegalTexts() {
      if (!this.company?.id) {
        console.warn("Company ID not available yet");
        return;
      }

      this.loading = true;

      try {
        const url = `/api/company/${this.company.id}/legal-texts/resolve?keys[]=privacy_notice&locale=${this.currentLocale}`;
        const response = await axios.get(url);

        this.legalTextsData = response.data || {};
      } catch (error) {
        console.error("Error fetching legal texts:", error);
        this.legalTextsData = {};
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    if (this.company?.id) {
      await this.fetchLegalTexts();
    }
  },
  watch: {
    company(newVal) {
      if (newVal?.id && Object.keys(this.legalTextsData).length === 0) {
        this.fetchLegalTexts();
      }
    },
  },
}
</script>

<style scoped>
/* ═══════════════════════════════════════
   PAGE LAYOUT
   ═══════════════════════════════════════ */
.agreement-page {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  background: #f7f8fc;
  overflow-x: hidden;
}

.agreement-page__container {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

/* ═══════════════════════════════════════
   LOADING SKELETON
   ═══════════════════════════════════════ */
.skeleton-wrapper {
  padding: 12px 0;
  animation: fadeIn 0.3s ease-in;
}

.skeleton-title {
  height: 28px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 24px;
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}

.skeleton-line {
  height: 14px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 10px;
  width: 100%;
}

.skeleton-line.short {
  width: 75%;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* ═══════════════════════════════════════
   CONTENT
   ═══════════════════════════════════════ */
.py-5 {
  padding: 3rem 0;
}

.text-center {
  text-align: center;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.information-content {
  line-height: 1.6;
  color: #333;
  font-size: 16px;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

/* ═══════════════════════════════════════
   LEGAL SECTION — API'den gelen HTML
   ═══════════════════════════════════════ */
.legal-section {
  margin-bottom: 20px;
  font-size: 16px;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

.legal-section:deep(article) {
  padding: 0;
}

.legal-section:deep(p),
.legal-section:deep(span),
.legal-section:deep(div),
.legal-section:deep(li),
.legal-section:deep(a),
.legal-section:deep(address) {
  font-size: 16px;
}

.legal-section:deep(img) {
  max-width: 100%;
  height: auto;
}

/* ─── Headings ─── */
.legal-section:deep(h1) {
  font-size: 22px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 16px;
  text-align: center;
  border-bottom: 2px solid #8d8c8c;
  padding-bottom: 10px;
}

.legal-section:deep(h2) {
  font-size: 19px;
  font-weight: 600;
  color: #000;
  margin-top: 22px;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #ecf0f1;
}

.legal-section:deep(h3) {
  font-size: 17px;
  font-weight: 600;
  color: #000;
  margin-top: 18px;
  margin-bottom: 8px;
}

.legal-section:deep(h4),
.legal-section:deep(h5),
.legal-section:deep(h6) {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  margin-top: 14px;
  margin-bottom: 6px;
}

/* ─── Paragraph ─── */
.legal-section:deep(p) {
  margin-bottom: 12px;
  line-height: 1.6;
  color: #333;
}

/* ─── Lists ─── */
.legal-section:deep(ul) {
  margin: 12px 0;
  padding-left: 24px;
  list-style-type: disc;
}

.legal-section:deep(ol) {
  margin: 12px 0;
  padding-left: 24px;
  list-style-type: decimal;
}

.legal-section:deep(li) {
  margin-bottom: 6px;
  line-height: 1.5;
}

.legal-section:deep(li::marker) {
  color: #000;
  font-weight: bold;
}

/* ─── Quill Alignment ─── */
.legal-section:deep(.ql-align-center) {
  text-align: center;
}

.legal-section:deep(.ql-align-right) {
  text-align: right;
}

.legal-section:deep(.ql-align-justify) {
  text-align: justify;
}

.legal-section:deep(.ql-align-left) {
  text-align: left;
}

/* ─── Quill Indentation ─── */
.legal-section:deep(.ql-indent-1) {
  padding-left: 2em;
}

.legal-section:deep(.ql-indent-2) {
  padding-left: 4em;
}

.legal-section:deep(.ql-indent-3) {
  padding-left: 6em;
}

.legal-section:deep(.ql-indent-4) {
  padding-left: 8em;
}

.legal-section:deep(.ql-indent-5) {
  padding-left: 10em;
}

.legal-section:deep(.ql-indent-6) {
  padding-left: 12em;
}

.legal-section:deep(.ql-indent-7) {
  padding-left: 14em;
}

.legal-section:deep(.ql-indent-8) {
  padding-left: 16em;
}

/* ─── Quill Font Sizes ─── */
.legal-section:deep(.ql-size-small) {
  font-size: 16px;
}

.legal-section:deep(.ql-size-large) {
  font-size: 24px;
}

.legal-section:deep(.ql-size-huge) {
  font-size: 32px;
}

/* ─── Quill Font Families ─── */
.legal-section:deep(.ql-font-serif) {
  font-family: Georgia, Times New Roman, serif;
}

.legal-section:deep(.ql-font-monospace) {
  font-family: Monaco, Courier New, monospace;
}

/* ─── Text Formatting ─── */
.legal-section:deep(strong) {
  font-weight: bold;
}

.legal-section:deep(em) {
  font-style: italic;
}

.legal-section:deep(u) {
  text-decoration: underline;
}

.legal-section:deep(s) {
  text-decoration: line-through;
}

.legal-section:deep(sub) {
  vertical-align: sub;
  font-size: smaller;
}

.legal-section:deep(sup) {
  vertical-align: super;
  font-size: smaller;
}

/* ─── Code Block ─── */
.legal-section:deep(pre) {
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  overflow-x: auto;
  font-family: Monaco, Courier New, monospace;
  font-size: 16px;
}

.legal-section:deep(code) {
  background-color: #f4f4f4;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: Monaco, Courier New, monospace;
  font-size: 16px;
}

/* ─── Blockquote ─── */
.legal-section:deep(blockquote) {
  border-left: 4px solid #ccc;
  margin: 12px 0;
  padding-left: 14px;
  color: #666;
  font-style: italic;
  font-size: 16px;
}

/* ─── Quill List Alignment ─── */
.legal-section:deep(ul.ql-align-center),
.legal-section:deep(ol.ql-align-center) {
  text-align: center;
  list-style-position: inside;
}

.legal-section:deep(ul.ql-align-right),
.legal-section:deep(ol.ql-align-right) {
  text-align: right;
  list-style-position: inside;
}

.legal-section:deep(ul.ql-align-justify),
.legal-section:deep(ol.ql-align-justify) {
  text-align: justify;
}

/* ─── Address ─── */
.legal-section:deep(address) {
  background-color: #f8f9fa;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #dee2e6;
  font-style: normal;
  margin: 16px 0;
}

.legal-section:deep(address strong) {
  color: #2c3e50;
  font-weight: 600;
  display: block;
  margin-bottom: 6px;
}

.legal-section:deep(address a) {
  color: #2980b9;
  text-decoration: none;
}

.legal-section:deep(address a:hover) {
  text-decoration: underline;
}

/* ─── Table ─── */
.legal-section:deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 16px 0;
  font-size: 16px;
}

.legal-section:deep(table th),
.legal-section:deep(table td) {
  border: 1px solid #dee2e6;
  padding: 10px 12px;
  text-align: left;
  vertical-align: top;
}

.legal-section:deep(table th) {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
}

.legal-section:deep(table tr:nth-child(even)) {
  background-color: #fafafa;
}

/* ═══════════════════════════════════════
   RESPONSIVE — Tablet
   ═══════════════════════════════════════ */
@media (max-width: 768px) {

  .legal-section:deep(h1) {
    font-size: 20px;
    margin-bottom: 14px;
  }

  .legal-section:deep(h2) {
    font-size: 18px;
    margin-top: 18px;
  }

  .legal-section:deep(h3) {
    font-size: 16px;
  }

  .legal-section:deep(ul),
  .legal-section:deep(ol) {
    margin: 10px 0;
    padding-left: 20px;
  }

  /* Indentation — mobilde daralt */
  .legal-section:deep(.ql-indent-1) {
    padding-left: 1.5em;
  }

  .legal-section:deep(.ql-indent-2) {
    padding-left: 3em;
  }

  .legal-section:deep(.ql-indent-3) {
    padding-left: 4.5em;
  }

  .legal-section:deep(.ql-indent-4) {
    padding-left: 6em;
  }

  .legal-section:deep(.ql-indent-5) {
    padding-left: 7.5em;
  }

  .legal-section:deep(.ql-indent-6) {
    padding-left: 9em;
  }

  .legal-section:deep(.ql-indent-7) {
    padding-left: 10.5em;
  }

  .legal-section:deep(.ql-indent-8) {
    padding-left: 12em;
  }

  /* Tablo yatay scroll */
  .legal-section:deep(table) {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    max-width: 100%;
  }

  .legal-section:deep(table th),
  .legal-section:deep(table td) {
    padding: 8px 10px;
    font-size: 14px;
    white-space: normal;
    word-break: break-word;
    min-width: 200px;
    max-width: 75vw;
  }

  .skeleton-title {
    height: 24px;
    width: 80%;
    margin-bottom: 18px;
  }

  .skeleton-line {
    height: 12px;
    margin-bottom: 8px;
  }
}

/* ═══════════════════════════════════════
   RESPONSIVE — Mobil
   ═══════════════════════════════════════ */
@media (max-width: 480px) {

  .legal-section:deep(h1) {
    font-size: 18px;
    margin-bottom: 12px;
    padding-bottom: 8px;
  }

  .legal-section:deep(h2) {
    font-size: 16px;
    margin-top: 16px;
    margin-bottom: 8px;
  }

  .legal-section:deep(h3) {
    font-size: 15px;
  }

  .legal-section:deep(p) {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .legal-section:deep(li) {
    font-size: 14px;
  }

  .legal-section:deep(ul),
  .legal-section:deep(ol) {
    padding-left: 18px;
  }

  .legal-section:deep(blockquote) {
    padding-left: 10px;
    margin: 10px 0;
  }

  .legal-section:deep(address) {
    padding: 10px;
  }

  /* Indentation — küçük ekranda daha da daralt */
  .legal-section:deep(.ql-indent-1) {
    padding-left: 1em;
  }

  .legal-section:deep(.ql-indent-2) {
    padding-left: 2em;
  }

  .legal-section:deep(.ql-indent-3) {
    padding-left: 3em;
  }

  .legal-section:deep(.ql-indent-4) {
    padding-left: 4em;
  }

  .legal-section:deep(.ql-indent-5) {
    padding-left: 5em;
  }

  .legal-section:deep(.ql-indent-6) {
    padding-left: 6em;
  }

  .legal-section:deep(.ql-indent-7) {
    padding-left: 7em;
  }

  .legal-section:deep(.ql-indent-8) {
    padding-left: 8em;
  }

  .skeleton-title {
    width: 90%;
  }

  .skeleton-line.short {
    width: 85%;
  }
}

/* ═══════════════════════════════════════
   DESKTOP
   ═══════════════════════════════════════ */
@media (min-width: 960px) {

  .legal-section:deep(h1) {
    font-size: 24px;
    margin-bottom: 20px;
  }

  .legal-section:deep(h2) {
    font-size: 20px;
    margin-top: 25px;
    margin-bottom: 12px;
  }

  .legal-section:deep(h3) {
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .legal-section:deep(ul),
  .legal-section:deep(ol) {
    margin: 15px 0;
    padding-left: 32px;
  }

  .legal-section:deep(p) {
    margin-bottom: 15px;
  }
}
</style>